import { Component } from '@angular/core';

@Component({
  selector: 'app-create-permission',
  template: `
    <p>
      create-permission works!
    </p>
  `,
  styles: ``
})
export class CreatePermissionComponent {

}
